class KlaviyoSubscribe extends HTMLElement {
  constructor() {
    super();
    this.validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.currentStep = 1;
    this.hasTelStep = false;
    this.formElements = null;
  }
  
    connectedCallback() {
      this.initForm();
    }
  
  initForm() {
    const form = this.querySelector('form');
    if (!form) return;

    const emailInput = form.querySelector('input[type="email"]');
    if (!emailInput) return;
    const telInput = form.querySelector('input[type="tel"]');
    const messagesWrapper = this.querySelector('.klaviyo_messages');
    const successDiv = this.querySelector('.success_message');
    const errorDiv = this.querySelector('.error_message');
    const listInput = form.querySelector("[name='g']");
    const listId = listInput ? listInput.value : '';

    this.formElements = {
      form,
      emailInput,
      telInput,
      messagesWrapper,
      successDiv,
      errorDiv
    };

    this.hasTelStep = Boolean(telInput);
    this.setStep(this.hasTelStep ? 1 : 2, { focus: false });

    const handleEmailInput = () => {
      const val = emailInput.value.trim();
      if (val.length > 1 && val.match(this.validEmailRegex)) {
        this.hideError();
      }
    };

    emailInput.addEventListener('change', handleEmailInput);
    emailInput.addEventListener('input', handleEmailInput);
    emailInput.addEventListener('focus', handleEmailInput);

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const emailValue = emailInput.value.trim();

      if (this.hasTelStep && this.currentStep === 1) {
        if (!(emailValue.length > 1 && emailValue.match(this.validEmailRegex))) {
          this.showError('Invalid Email');
          return;
        }

        this.hideError();
        this.setStep(2);
        return;
      }

      this.handleFormSubmit(form, listId, emailValue);
    });
  }

  setStep(step, options = {}) {
    const { focus = true } = options;
    this.currentStep = step;

    if (!this.formElements) {
      return;
    }

    const { form, emailInput, telInput } = this.formElements;
    const submitInput = form ? form.querySelector('input[type="submit"]') : null;
    const showTel = step === 2 && !!telInput;

    if (emailInput) {
      emailInput.classList.toggle('footer-form-input--hidden', showTel);
      if (!showTel && focus) {
        emailInput.focus();
      }
    }

    if (telInput) {
      telInput.classList.toggle('footer-form-input--hidden', !showTel);
      if (focus && showTel) {
        setTimeout(() => {
        if (!telInput.classList.contains('footer-form-input--hidden')) {
          telInput.focus();
          telInput.setSelectionRange?.(telInput.value.length, telInput.value.length);
        }
      }, 100);
      }
    }

    if (form) {
      form.dataset.step = String(step);
    }

    if (submitInput) {
      if (!submitInput.dataset.defaultValue) {
        submitInput.dataset.defaultValue = submitInput.value;
      }
      submitInput.value = showTel ? 'Text Me' : submitInput.dataset.defaultValue;
    }
  }

  showError(message) {
    if (!this.formElements) return;

    const { errorDiv } = this.formElements;
    if (errorDiv) {
      errorDiv.innerHTML = `<div>${message}</div>`;
      errorDiv.style.display = 'block';
    }
  }

  hideError() {
    if (!this.formElements) return;

    const { errorDiv } = this.formElements;
    if (errorDiv) {
      errorDiv.innerHTML = '';
      errorDiv.style.display = 'none';
    }
  }
  
    handleFormSubmit(form, listId, email) {
      let fieldsArr = ["Accepts Marketing"];
      let fieldsObj = {};
      let klaviyoObj = {};
    
      form.querySelectorAll('input').forEach(input => {
        if (
          input.type !== 'submit' &&
          input.type !== 'hidden' &&
          input.type !== 'email' &&
          input.name !== '$consent'
        ) {
          fieldsArr.push(input.name);
          fieldsObj[input.name] = input.value;
        }
        if (input.name === '$source') {
          fieldsArr.push('$source');
          fieldsObj['$source'] = input.value;
        }
      });
    
      fieldsObj['Accepts Marketing'] = true;
      klaviyoObj = { $fields: fieldsArr, ...fieldsObj };
    
      // Submit phone to Netlify SMS endpoint if present
      const telInput = form.querySelector('[type="tel"]');
      const phone = telInput?.value?.trim();
      const source = fieldsObj['$source'] || '';
      
      if (telInput && phone.length) {
        const smsUrl = `https://knickey.netlify.app/.netlify/functions/sms-consent?list_id=${listId}&email=${encodeURIComponent(email)}&phone=${encodeURIComponent(phone)}&source=${encodeURIComponent(source)}&marketing=true`;
    
        const requestOptions = {
          method: "GET",
          redirect: "follow"
        };
    
        fetch(smsUrl, requestOptions)
          .then((response) => response.text())
          .then((result) => console.log("SMS Consent Result:", result))
          .catch((error) => console.error("SMS Consent Error:", error));
      }
    
    this.handleSubmit(listId, klaviyoObj, email, form, "");
    }  
  
    handleSubmit(listId, obj, email, formSelector, redirectUrl) {
      const messagesDiv = this.querySelector('.error_message');
      const successDiv = this.querySelector('.success_message');
      messagesDiv.innerHTML = '';
  
      if (email.length > 1 && email.match(this.validEmailRegex)) {
        if (listId !== '123456') {
          this.subscribe(listId, email, obj).then(response => {
            if (response.success) {
              messagesDiv.style.display = 'none';
              if (redirectUrl.length) {
                window.location.replace(redirectUrl);
              } else {
                successDiv.style.display = 'block';
              }
              formSelector.querySelectorAll(".footer-form-input").forEach($i => {
                $i.value = "";
              });
              formSelector.classList.add("success");
              if (this.hasTelStep) {
                this.setStep(1);
              }
            } else {
              successDiv.style.display = 'none';
              messagesDiv.style.display = 'block';
              response.errors.forEach(error => {
                let errorDiv = document.createElement('div');
                errorDiv.textContent = error;
                messagesDiv.appendChild(errorDiv);
              });
            }
          });
        } else {
          messagesDiv.style.display = 'block';
          messagesDiv.innerHTML = '<div>Please use a valid Klaviyo ID.</div>';
        }
      } else {
        if (this.hasTelStep) {
          this.setStep(1);
        }
        messagesDiv.style.display = 'block';
        messagesDiv.innerHTML = '<div>Invalid Email</div>';
      }
    }
  
    subscribe(listId, email, data) {
      return window.subscribe(listId, email, data);
    }
    
  }
  
  // Global subscribe function - always requires listId and email
  window.subscribe = function(listId, email, data = {}) {
    // Validate required parameters
    if (!listId || typeof listId !== 'string') {
      return Promise.reject(new Error('listId is required and must be a string'));
    }
    
    if (!email || typeof email !== 'string') {
      return Promise.reject(new Error('email is required and must be a string'));
    }
    
    // Validate email format
    const validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.match(validEmailRegex)) {
      return Promise.reject(new Error('Invalid email format'));
    }
    
    const url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
  
    const payload = {
      g: listId,
      email: email, 
      ...data
    };
  
    const formData = new URLSearchParams();
  
    for (let key in payload) {
      if (Array.isArray(payload[key])) {
        payload[key].forEach(value => {
          formData.append(key, value);
        });
      } else {
        formData.append(key, payload[key]);
      }
    }
  
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: formData.toString()
    })
    .then(response => response.json())
    .then(data => {
      console.log("FORM DATA", data);
      if (data.success) {
        return { success: true };
      } else {
        return { success: false, errors: data.errors || ['Subscription failed'] };
      }
    })
    .catch(error => {
      return { success: false, errors: [error.message] };
    });
  };
  
  if (!customElements.get("klaviyo-subscribe")) {
    customElements.define('klaviyo-subscribe', KlaviyoSubscribe);
  }